/**
 * Variants for the cost-estimate PSL experiment (COST_ESTIMATE_PSL_EXPERIMENT, MER-5374).
 * Keys are an Amplitude contract — they must match the experiment's variant keys exactly.
 */
export enum CostEstimateExperimentVariant {
  CONTROL = 'control',
  COST_ESTIMATE = 'cost_estimate',
}
